<div class="single-equipment-air-section">
  <div class="single-equipment-air-section__handsets">
    <h3 translate>equipment.details.nav-tabs.overview.handsets.title</h3>
    <button class="vox-btn btn btn-success" [disabled]="company && company.readOnly" (click)="openAddHandsetPopup()">
      <i class="icon-small-add-circle"></i>
      <span translate>equipment.details.buttons.add-handset</span>
    </button>
  </div>
  <div class="equipment-handsets">
    <table>
      <thead>
        <tr>
          <td translate>equipment.details.handsets.table.id</td>
          <td translate>equipment.details.handsets.table.ipui</td>
          <td translate>equipment.details.handsets.table.user</td>
          <td translate>equipment.details.handsets.table.outbound-did</td>
          <td translate>equipment.details.handsets.table.actions</td>
        </tr>
      </thead>
      <tbody *ngIf="!loading">
        <ng-container *ngFor="let h of equipment.handsets; let i = index">
          <tr *ngIf="h.isLoading" class="user-data-row">
            <td colspan="7">
              <ngx-skeleton-loader></ngx-skeleton-loader>
            </td>
          </tr>
          <tr *ngIf="!h.isLoading" class="user-data-row">
            <td>{{h.id}}</td>
            <td>{{h.ipui}}</td>
            <ng-container *ngIf="h.user">
              <td>{{h.user.first_name}} {{h.user.last_name}} ({{h.user.extension.number}})</td>
            </ng-container>
            <ng-container *ngIf="!h.user">
              <td><b> - </b></td>
            </ng-container>
            <td class="user-data-row">{{h.outbound_did || '-'}}</td>
            <td class="actions">
              <div
                [ngbTooltip]="(h.user ? 'equipment.details.handsets.actions.outbound-did' : 'equipment.details.handsets.actions.outbound-did-missing-user') | translate">
                <button class="vox-btn btn btn-success mright"
                  [disabled]="company && company.readOnly || !equipment.pbx || !h.user" (click)="updateOutboundDid(h)">
                  <i class="icon-small-call"></i>
                </button>
              </div>
              <ng-container *ngIf="h.user">
                <button class="vox-btn btn btn-danger mright" [disabled]="company && company.readOnly"
                  (click)="unassignFromUser(h)">
                  <i class="icon-big-user" style="font-size: 24px;"></i>
                </button>
              </ng-container>
              <ng-container *ngIf="!h.user && equipment.pbx">
                <button class="vox-btn btn btn-success mright" [disabled]="company && company.readOnly"
                  (click)="openAssignToUserPopup(h)">
                  <i class="icon-big-user" style="font-size: 24px;"></i>
                </button>
              </ng-container>
              <button class="vox-btn btn btn-danger" [disabled]="company && company.readOnly"
                (click)="deleteHandset(h)">
                <i class="icon-small-delete"></i>
              </button>
            </td>
          </tr>
        </ng-container>
      </tbody>
      <tbody *ngIf="loading">
        <tr *ngFor="let i of [1,2,3,4]">
          <td colspan="4">
            <ngx-skeleton-loader></ngx-skeleton-loader>
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="equipment.handsets.length === 0">
        <tr>
          <td colspan="4" translate>equipment.details.handsets.empty</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>